export default __webpack_public_path__ + "static/media/rnd03_2.0e81ad36.png";